'use client';

import React, { useCallback, useMemo } from 'react';
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
// import styled from '@benzinga/themetron';

export type IconProp =
  | IconDefinition
  | {
      icon: (string | number | never[])[];
    };

export interface IconProps {
  className?: string;
  duotoneColor?: [string | undefined, string | undefined];
  duotoneOpacity?: [number | undefined, number | undefined];
  icon: IconProp;
  spin?: boolean;
  strokeWidth?: number;
  style?: React.CSSProperties;
  title?: string;
  trimX?: boolean;
  trimY?: boolean;
}

export const Icon = ({
  className,
  duotoneColor,
  duotoneOpacity,
  icon,
  strokeWidth = 1,
  style,
  title,
  trimX,
  trimY,
  ...divProps
}: IconProps & React.HTMLAttributes<HTMLDivElement>) => {
  const viewBox = useMemo(() => `0 0 ${icon.icon[0]} ${icon.icon[1]}`, [icon]);
  const path = useMemo(() => icon.icon[4], [icon]);
  const getOpacity = useCallback((i: number) => duotoneOpacity && duotoneOpacity[i], [duotoneOpacity]);
  const getColor = useCallback(
    (i: number) => (duotoneColor && duotoneColor[i] ? duotoneColor[i] : 'currentColor'),
    [duotoneColor],
  );

  return (
    <div {...divProps} className={className} style={style}>
      <svg
        aria-hidden="true"
        className="leading-none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        style={{
          height: trimY ? undefined : '1em',
          width: trimX ? undefined : '1em',
        }}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
      >
        {title && <title>{title}</title>}
        {Array.isArray(path) ? (
          (path as string[]).map((p, i) => <path d={p} fill={getColor(i)} fillOpacity={getOpacity(i)} key={i} />)
        ) : (
          <path d={path.toString()} fill="currentColor" />
        )}
      </svg>
    </div>
  );
};

// const IconWrapper = styled.div`
//   display: inline-grid;
// `;

// Icon.defaultProps = {
//   duotoneOpacity: 0.4,
// };
